import React, { useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import { CloseIcon } from "../../../assets/Icons";
import AssetViewer from './assetViewer';

const ViewModal = ({ handleCloseFileViewer, viewFile , filePath }) => {


    return (
        <Modal show={viewFile} onHide={() => handleCloseFileViewer()} centered size="xl" >
            <Modal.Header className='modalheader'>
                File Preview
                <span onClick={() => handleCloseFileViewer()} ><CloseIcon /></span>
            </Modal.Header>
            <Modal.Body>
                <div className='model-parent'>
                 <AssetViewer theeDAssetFile={filePath} />
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default ViewModal
